export default __webpack_public_path__ + "static/media/background@2x.31868f65.png";